import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <div className="footer-content">
          <div className="footer-contacts">
            <span className="footer-phone">Call (833) 250-9900</span>
            <span className="footer-working-time">
              8:00 AM - 7:00 PM CST&nbsp;&nbsp;&nbsp;Monday - Friday
            </span>
          </div>
          <div className="footer-copyright">
            <div className="footer-copyright-text">
              Northeast Agencies Inc, in CA doing business as Northeast Agencies
              Insurance Services, CA license #0B45336.
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
